export default {
  "user": {
    "role_name": "角色名称",
    "description": "描述",
    "create_role": "创建角色",
    "assign_role_permissions": "分配角色权限",
    "address_name": "地址名称",
    "create_address": "创建地址"
  }
}